import { addDays, differenceInCalendarDays, startOfWeek, subWeeks } from "date-fns";
import { calendarDate, calendarDateKey } from "@/shared/utils/calendarDate";

const WEEKS_EACH_WAY = 104;

/** A fixed Monday-aligned index of days around `todayKey`, so day N always belongs to week floor(N / 7). */
export function createAgendaDays(todayKey: string) {
  const first = startOfWeek(subWeeks(calendarDate(todayKey), WEEKS_EACH_WAY), { weekStartsOn: 1 });
  const weekCount = WEEKS_EACH_WAY * 2 + 1;
  const dayCount = weekCount * 7;
  const dayKeyAt = (index: number) => calendarDateKey(addDays(first, index));
  const dayIndexOf = (dateKey: string) => {
    const index = differenceInCalendarDays(calendarDate(dateKey), first);
    return index >= 0 && index < dayCount ? index : null;
  };
  return {
    dayCount,
    weekCount,
    dayKeyAt,
    dayIndexOf,
    weekOfDay: (dayIndex: number) => Math.floor(dayIndex / 7),
    weekDayKeys: (weekIndex: number) => Array.from({ length: 7 }, (_, day) => dayKeyAt(weekIndex * 7 + day)),
  };
}

export type AgendaDays = ReturnType<typeof createAgendaDays>;
